import React from 'react';
import MaskedTextField from 'core/components/MaskedTextField';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';
import {
  placeholderByType,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

const ssnMask = [{
  mask: '000-00-0000',
  lazy: true,
}];

const einMask = [{
  mask: '00-0000000',
  lazy: true,
}];

export default function TaxpayerNumber({ field, value, onChange }: FieldComponentProps) {
  const mask = /ssn/i.test(field?.type ?? '') ? ssnMask : einMask;
  const placeholder = placeholderByType[field.type];
  return (
    <MaskedTextField
      mask={mask}
      autoFocus
      fullWidth
      value={value?.value ?? ''}
      placeholder={placeholder}
      onAccept={(data: string) => {
        onChange?.({ ...value, value: data });
      }}
    />
  );
}
